import React from 'react';
import TextProcessor from "@/components/common/TextProcessor";
import { type Block } from "@/sections/SectionRenderer";

interface ValuePropositionData extends Block {
  tagline: string;
  text: string;
}

export const ValueProposition = ({ data }: { data: ValuePropositionData }) => {
  const { id, tagline, text } = data;

  return (
    <section id={id} className="py-16 px-4 md:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-sm font-bold mb-4 uppercase tracking-wider">{tagline}</p>
        <h2 className="text-3xl md:text-4xl font-light mb-6">
          <TextProcessor>
            {text}
          </TextProcessor>
        </h2>
      </div>
    </section>
  );
};
